module.exports = "/_next/static/images/5478326bcabb5ebc44e110bb75bf63ed-girl-holding-card@lg.jpg.webp";